module.exports = __webpack_public_path__ + "assets/img/3.4f4ff6b2.jpg";